// extracted by mini-css-extract-plugin
module.exports = {"customer":"EuRqxjyzh0TBORit7lXJH","avatar":"_10Y-lvqzckL7bZnpO3q9WG","contact":"_3mf8kWb4kn_cPADQM5ntZS","boxAdd":"puBkuvMbwj4pHm5llqm-g"};